import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import StatCard from "../Components/StatCard";
import { ButtonBase, Paper } from "@mui/material";
import { ApiManager } from "../Services/Networking";
import { useEffect } from "react";
import dayjs from "dayjs";
import { useState } from "react";
import { Check, Luggage, UserPlus, Users } from "lucide-react";
import { CheckCheck } from "lucide-react";
import { ClockPlus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Layout from "../Components/Layout";

export default function MainGrid() {
  const navigate = useNavigate();
  const [holidays, setHolidays] = useState([]);
  useEffect(() => {
    const fetchHolidays = async () => {
      const res = await ApiManager.getUpcomingHolidays();
      if (res.status === "success") setHolidays(res.data);
    };
    fetchHolidays();
  }, []);
  const [data, setData] = useState([
    {
      title: "Number of Employees",
      value: 0,
      color: "#4CAF50",
      icon: <Check color="#4CAF50" size={32} />,
    },
    {
      title: "Number of Departments",
      value: 0,
      color: "#2196F3",
      icon: <CheckCheck color="#2196F3" size={32} />,
    },
    {
      title: "New Employees (This month)",
      value: 0,
      color: "#F44336",
      icon: <ClockPlus color="#F44336" size={32} />,
    },
  ]);

  const actions = [
    {
      icon: <UserPlus size={28} />,
      label: "Add Employee",
      path: "/employees/form",
    },
    { icon: <Users size={28} />, label: "Employee List", path: "/employees" },
    {
      icon: <Luggage size={28} />,
      label: "Add Holiday",
      path: "/holiday/form",
    },
  ];

  return (
    <Layout name="DASHBOARD">
      <Grid container spacing={2} columns={12}>
        <Grid size={{ xs: 12 }}>
          <Typography component="h2" variant="h6">
            Overview
          </Typography>
        </Grid>
        {data.map((card, index) => (
          <Grid key={index} size={{ xs: 12, sm: 12 / 3 }}>
            <StatCard {...card} />
          </Grid>
        ))}

        <Grid size={{ xs: 7 }}>
          <Paper sx={{ height: "100%", padding: 2, overflow: "auto" }}>
            <Typography variant="h6">Upcoming Holidays</Typography>
            <Stack spacing={2} mt={3}>
              {holidays.length > 0 ? (
                holidays.map((h) => (
                  <Paper key={h.id} variant="outlined" sx={{ p: 2 }}>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Box>
                        <Typography variant="subtitle1" fontWeight="bold">
                          {h.name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {h.holiday_type}
                        </Typography>
                      </Box>
                      <Typography variant="body2" fontWeight="medium">
                        {dayjs(h.from_date).format("DD MMM YYYY")}
                        {h.from_date !== h.to_date &&
                          ` - ${dayjs(h.to_date).format("DD MMM YYYY")}`}
                      </Typography>
                    </Stack>
                  </Paper>
                ))
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No upcoming holidays
                </Typography>
              )}
            </Stack>
          </Paper>
        </Grid>
        <Grid size={{ xs: 5 }}>
          <Paper sx={{ height: "100%", padding: 2 }}>
            <Typography variant="h6">Quick Actions</Typography>
            <Stack spacing={2} mt={3}>
              {actions.map((action, i) => (
                <ButtonBase
                  key={i}
                  onClick={() => navigate(action.path)}
                  sx={{
                    width: "100%",
                    textAlign: "left",
                    borderRadius: 1,
                  }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      transition: "0.2s",
                      "&:hover": {
                        bgcolor: "action.hover",
                        borderColor: "primary.main",
                      },
                    }}
                  >
                    {action.icon}
                    <Typography variant="h5" sx={{ fontWeight: 500 }}>
                      {action.label}
                    </Typography>
                  </Paper>
                </ButtonBase>
              ))}
            </Stack>
          </Paper>
        </Grid>
      </Grid>
    </Layout>
  );
}
